export default "__VITE_ASSET__BNVNLYtG__"